import React from 'react';
import { useForm } from 'react-hook-form';
import { Button, Input, Modal, RowContainer } from '../../../common';

const EditScheduleModal = ({ defaultValues, onSave, closeForm }) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    const onSubmit = (data) => {
        const postData = {
            name: data.scheduleName,
            description: data.scheduleDescription,
        };

        onSave && onSave(postData);
    };

    return (
        <Modal title="Edit Schedule" closeModal={closeForm}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="pb-3">
                    <Input
                        defaultValue={defaultValues.name}
                        error={errors.scheduleName}
                        placeholder="Schedule Name must be unique"
                        message={errors.scheduleName ? 'Schedule Name is required' : undefined}
                        label="Schedule Name"
                        {...register('scheduleName', { required: true })}
                    />
                </div>
                <div className="pb-3">
                    <Input
                        defaultValue={defaultValues.description}
                        error={errors.scheduleDescription}
                        message={
                            errors.scheduleDescription
                                ? 'Schedule Description is required'
                                : undefined
                        }
                        label="Schedule Description"
                        {...register('scheduleDescription', { required: true })}
                    />
                </div>
                <RowContainer spacing="medium" className="justify-center">
                    <Button type="button" onClick={() => closeForm && closeForm()}>
                        Cancel
                    </Button>
                    <Button type="submit">Submit</Button>
                </RowContainer>
            </form>
        </Modal>
    );
};

export default EditScheduleModal;
